import { useState } from "react";

export default function ContactForm() {
  const [form, setForm]   = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | ok | error

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setStatus("sending");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.status === "ok") {
        setStatus("ok");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <form className="contact-form" onSubmit={submit} id="contact">
      <div className="field-row">
        <div className="field">
          <label>Nombre *</label>
          <input value={form.name} onChange={update("name")} required />
        </div>
        {/* <div className="field">
          <label>Teléfono</label>
          <input value={form.phone} onChange={update("phone")} placeholder="+34..." />
        </div> */}
      </div>
      <div className="field">
        <label>Correo *</label>
        <input type="email" value={form.email} onChange={update("email")} required />
      </div>
      <div className="field">
        <label>Mensaje *</label>
        <textarea
          rows={4}
          value={form.message}
          onChange={update("message")}
          required
          style={{ resize: "vertical" }}
        />
      </div>
      {status === "ok" && (
        <p className="contact-success">✓ Mensaje enviado. Te responderemos pronto.</p>
      )}
      {status === "error" && (
        <p className="error-text">No se pudo enviar. Intenta de nuevo.</p>
      )}
      <button className="btn btn-primary" style={{margin: "auto", display: "block"}} disabled={status === "sending"}>
        {status === "sending" ? "Enviando..." : "Enviar mensaje"}
      </button>
    </form>
  );
}